"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var Header_1 = require("../../components/Header");

var Footer_1 = __importDefault(require("../../components/Footer"));

var Step1_1 = __importDefault(require("./Step1"));

var Step2_1 = __importDefault(require("./Step2"));

var Step3_1 = __importDefault(require("./Step3"));

var Confirmation_1 = __importDefault(require("./Confirmation"));

var LoadingModal_1 = require("../../components/LoadingModal");

require("../../assets/scss/components.scss");

exports.Stepper = function (props) {
  var activeStep = props.activeStep,
      goPreviousStep = props.goPreviousStep,
      sendBackOtp = props.sendBackOtp,
      sendBackOtpDisabled = props.sendBackOtpDisabled,
      callPostIban = props.callPostIban,
      onSubmit = props.onSubmit,
      ldeURL = props.ldeURL,
      creditsURL = props.creditsURL,
      customerServiceURL = props.customerServiceURL,
      termsOfUseURL = props.termsOfUseURL,
      showLoadingModal = props.showLoadingModal,
      _a = props.isFooter,
      isFooter = _a === void 0 ? true : _a,
      cookieEvent = props.cookieEvent;
  var stepperProps = {
    activeStep: activeStep,
    variant: "simple",
    displayProgress: true,
    header: ["Espace Paiement", "Espace Paiement", "Espace Paiement", ""]
  };
  var argsHeader = {
    srcLogo: props.srcLogo,
    currentBrandCode: props.currentBrandCode,
    labelClose: "Quitter le paiement",
    destClose: props.destClose
  };
  var argsFooter = {
    customerServiceURL: customerServiceURL,
    termsOfUseURL: termsOfUseURL,
    ldeURL: ldeURL,
    creditsURL: creditsURL,
    isFooter: isFooter,
    cookieEvent: cookieEvent
  };
  return react_1.default.createElement("div", {
    className: "container-fluid p-0 e-tip-index"
  }, react_1.default.createElement(Header_1.Header, __assign({}, argsHeader)), react_1.default.createElement("div", {
    className: "container p-0 position-relative"
  }, react_1.default.createElement(LoadingModal_1.LoadingModal, {
    isDisabled: showLoadingModal
  }), react_1.default.createElement(react_theme_components_1.SzStepper, __assign({}, stepperProps), react_1.default.createElement(react_theme_components_1.SzStepper.SzHeader, null), react_1.default.createElement(react_theme_components_1.SzStepper.SzStep, {
    index: 0
  }, react_1.default.createElement(Step1_1.default, __assign({}, props, {
    goToNextStep: onSubmit,
    callPostIban: callPostIban
  }))), react_1.default.createElement(react_theme_components_1.SzStepper.SzStep, {
    index: 1
  }, react_1.default.createElement(Step2_1.default, __assign({}, props, {
    goPreviousStep: goPreviousStep,
    goToNextStep: onSubmit
  }))), react_1.default.createElement(react_theme_components_1.SzStepper.SzStep, {
    index: 2
  }, react_1.default.createElement(Step3_1.default, __assign({}, props, {
    goPreviousStep: goPreviousStep,
    sendBackOtp: sendBackOtp,
    sendBackOtpDisabled: sendBackOtpDisabled,
    goToNextStep: onSubmit
  }))), react_1.default.createElement(react_theme_components_1.SzStepper.SzStep, {
    index: 3
  }, react_1.default.createElement(Confirmation_1.default, __assign({}, props))))), react_1.default.createElement(Footer_1.default, __assign({}, argsFooter)));
};